import React from 'react';
import { NEW_PASTE_URL } from 'config/data-sources';

type SubmissionOverlayProps = {
  submissionCode: string;
  submissionCopiedFlash: boolean;
  onCopyCode: () => void;
  onRefresh: () => void;
  refreshDisabled: boolean;
};

export const SubmissionOverlay: React.FC<SubmissionOverlayProps> = ({
  submissionCode,
  submissionCopiedFlash,
  onCopyCode,
  onRefresh,
  refreshDisabled,
}) => (
  <div className="submission-screen-overlay">
    <div className="submission-screen-content">
      <p className="submission-screen-eyebrow">Almost done</p>
      <h2 className="submission-screen-title">Submission ready</h2>
      <p className="submission-screen-description">
        Your paste code was copied to the clipboard. Paste it in the form that just opened, then click Submit.
      </p>
      <button
        type="button"
        className={`submission-code-display${submissionCopiedFlash ? ' is-copied' : ''}`}
        onClick={onCopyCode}
        aria-label="Copy paste code"
        title="Click to copy"
      >
        <span className="submission-code-text" aria-hidden>
          {submissionCode}
        </span>
        <span className="submission-code-hint">{submissionCopiedFlash ? 'Copied' : 'Click to copy'}</span>
      </button>
      <p className="submission-form-link-text">
        If the form didn&apos;t open,{' '}
        <a href={NEW_PASTE_URL} target="_blank" rel="noopener noreferrer" className="submission-form-link">
          open it here
        </a>
        .
      </p>
      <p className="submission-completion-message">
        When you&apos;re done,{' '}
        <button type="button" className="submission-refresh-button" onClick={onRefresh} disabled={refreshDisabled}>
          Refresh
        </button>{' '}
        the feed.
      </p>
    </div>
  </div>
);
